import React, { useEffect, useState, useContext } from "react";
import Checkbox from "@mui/material/Checkbox";
import StarIcon from "@mui/icons-material/Star";
import { useNavigate } from "react-router-dom";
import HeadBar from "../headBar/HeadBar";
import Breadcrumb from "../breacrumb/breadcrumb";
import { CurrentUserContext } from "../../../App";
import * as publicApi from "../../../service/publicApi";

export default function QuestionnairePublic() {
  const { setIsMessage } = useContext(CurrentUserContext);
  const navigate = useNavigate();
  const [title, setTitle] = useState({});
  const [questions, setQuestions] = useState([]);
  const [question, setQuestion] = useState([]);
  const [answers, setAnswers] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getQuestions();
  }, []);

  const getQuestions = async () => {
    setLoading(true);
    let res = await publicApi.getQuestionnaires(1, 10, "");
    setLoading(false);
    if (res?.data?.code === 200) {
      const questionList = res.data.questionnaire_list[0]?.question || [];
      const questionTexts = questionList.map((item) => item.question);
      setTitle({
        questionnaire_id: res.data.questionnaire_list[0]?.questionnaire_id,
        title: res.data.questionnaire_list[0]?.title,
      });
      setQuestion(questionTexts);
      setQuestions(questionList);
      setAnswers(new Array(questionList.length).fill(""));
    } else {
      setIsMessage({
        type: "error",
        data:
          res?.data?.message_th || "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const handleStarClick = (questionIndex, rating) => {
    setAnswers((prev) =>
      prev.map((ans, i) => (i === questionIndex ? rating + 1 : ans)),
    );
  };

  const handleTextChange = (questionIndex, text) => {
    setAnswers((prev) =>
      prev.map((ans, i) => (i === questionIndex ? text : ans)),
    );
  };

  const submitAnswers = async () => {
    for (let i = 0; i < questions.length; i++) {
      if (questions[i].require && !answers[i]) {
        setIsMessage({
          type: "warning",
          data: `กรุณากรอกคำตอบสำหรับ: ${questions[i].question}`,
        });
        return;
      }
    }

    let data = {
      questionnaire_id: title.questionnaire_id,
      title: title.title,
      question: question,
      answer: answers,
    };

    let res = await publicApi.submitQuestionnaires(data);
    if (res?.data?.code === 200) {
      setIsMessage({
        type: "success",
        data: res?.data?.message_th || "ส่งแบบสอบถามสำเร็จ",
      });
      setQuestion([]);
      setAnswers(new Array(questions.length).fill(""));
    } else {
      setIsMessage({
        type: "error",
        data: res?.data?.message_th || "เกิดข้อผิดพลาด",
      });
    }
  };

  return (
    <>
      {/* <HeadBar menu="questionnaire" /> */}
      <div className="global-page">
        <Breadcrumb
          pathItems={[
            { name: "หน้าหลัก", url: "/" },
            { name: "เเบบสำรวจความพึงพอใจ", url: "/questionnaire" },
          ]}
        />
        <div className="flex justify-center items-center">
          <div className="flex flex-col items-center my-[100px] min-w-[384px] w-[384px] gap-[28px] bg-white p-6">
            <h1 className="text-[26px]">{title?.title}</h1>

            {questions.map((item, index) => (
              <div key={index} className="w-full">
                <p className="ml-[10px] text-[18px]">
                  {item.question}{" "}
                  {item.require && <span className="text-red-500">*</span>}
                </p>
                {item.type === "STAR" ? (
                  <div>
                    {Array.from({ length: 5 }).map((_, i) => (
                      <>
                        <label className="sr-only">ให้คะแนน {i + 1} ดาว</label>

                        <Checkbox
                          key={i}
                          checked={i < answers[index]}
                          icon={<StarIcon className="text-gray-300" />}
                          checkedIcon={<StarIcon className="text-gold" />}
                          onChange={() => handleStarClick(index, i)}
                        />
                      </>
                    ))}
                  </div>
                ) : (
                  <>
                    <label htmlFor={`question-${index}`} className="sr-only">
                      {item.question}
                    </label>

                    <textarea
                      placeholder="กรอกความคิดเห็น"
                      value={answers[index]}
                      onChange={(e) => handleTextChange(index, e.target.value)}
                      className="w-full h-[100px] border border-gray-400 rounded p-2 text-gray-700 resize-none"
                    />
                  </>
                )}
              </div>
            ))}

            <div className="flex flex-row w-full gap-4">
              <button
                className="h-[52px] border bg-white rounded text-black w-full"
                onClick={() => navigate("/")}
              >
                ยกเลิก
              </button>
              <button
                className="h-[52px] bg-blue-500 text-white rounded w-full"
                onClick={submitAnswers}
              >
                ส่ง
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
